/**
 * Where a catalog hit for an experience variation opens: the player page,
 * by key. The key rides the content index's metadata because `sourceId` is
 * the variation's private surrogate (ADR-034). Null for a row synced before
 * the key was projected — a resync fills it in.
 */
export function variationPath(metadata: unknown): string | null {
    const { experienceId, variationKey } = (metadata ?? {}) as {
        experienceId?: unknown;
        variationKey?: unknown;
    };
    if (typeof experienceId !== "string" || typeof variationKey !== "string") {
        return null;
    }
    return `/exp/${encodeURIComponent(experienceId)}/${encodeURIComponent(variationKey)}`;
}
